/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_AccountsInputs */

const en_nav_accounts = /** @type {(inputs: Nav_AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accounts`)
};

/**
* | output |
* | --- |
* | "Accounts" |
*
* @param {Nav_AccountsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_accounts = /** @type {((inputs?: Nav_AccountsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_AccountsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_accounts(inputs)
});